import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMinus = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M19.5 12.5H4.5C4.224 12.5 4 12.276 4 12C4 11.724 4.224 11.5 4.5 11.5H19.5C19.776 11.5 20 11.724 20 12C20 12.276 19.776 12.5 19.5 12.5Z' />
  </svg>
);
export default SvgMinus;
